const KEY = 'chimp_anon_id'

// Returns a stable anonymous ID for this browser.
// Creates and persists a new UUID v4 on first call.
// Falls back to a one-time ID if localStorage is blocked (e.g. private mode in some browsers).
export const getAnonId = () => {
  try {
    let id = localStorage.getItem(KEY)
    if (!id) {
      id = crypto.randomUUID()
      localStorage.setItem(KEY, id)
    }
    return id
  } catch {
    return crypto.randomUUID()
  }
}
